import { useState, useEffect } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'

import { displayNotification } from '../../commonComponents/notifications/displayNotification'

import Body from '../../commonComponents/body/Body'
import ReactTable from '../../commonComponents/reactTable/ReactTable'
import { generateReportHeaders } from '../../utils/table.utils'
import { createNewRecord, fileUploadAPI, getAllData, getHeaders } from '../../services/common.service'
import ActionButton from '../../commonComponents/components/actionButton/ActionButton'
import { Button, Group, Modal, Text } from '@mantine/core'
import { IconDeviceMobileX } from '@tabler/icons-react'
import { deleteMasterDataById } from '../../services/master.service'
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { COLORS } from '../../constants/colors'



dayjs.extend(utc)
dayjs.extend(timezone)

const source = 'user_session_tokens';
let defaultSorting = { id: 'created_at', desc: true };
const UserSessionMaster = () => {
  const [pagination, setPagination] = useState({ page: 1, search: '', source, sort: [defaultSorting] })
  const [confirmationModal, setConfirmationModal] = useState({})

  const allRecordsQuery = useQuery({
    queryKey: ['all-records', source, pagination],
    queryFn: () => getAllData(pagination),
    select: (data) => {
      console.log(data);
      const result = data?.data?.map((item) => ({
        ...item,
        created_at: dayjs.utc(item?.created_at).utcOffset(330).format()
      }))
      console.log("result", result);
      
      return {...data, data: result}
    }
  })

  const tableHeadersQuery = useQuery({
    queryKey: ['table-headers', source],
    queryFn: () => getHeaders({ source }),
    select: data => {
      return { headers: generateReportHeaders(data?.[0]), data: data?.[0] }
    }
  })

  const uploadDataQuery = useMutation({
    mutationFn: body => fileUploadAPI({ body, tableName: source })
  })

  const createDataQuery = useMutation({
    mutationFn: body => createNewRecord({ body, source })
  })


  const deleteDataQuery = useMutation({
    mutationFn: id => deleteMasterDataById({ tableName: source, id })
  })

  useEffect(() => {
    if (pagination?.search) {
      setPagination(old => ({ ...old, page: 1 }))
    }
  }, [pagination?.search])

  const handleSorting = e => {
    // find the sorting data in the array from previous state
    const d = e(pagination.sort);
    setPagination(old => ({ ...old, sort: d }));
  }


  return (
    <>
      <Body>
        <ActionButton
          title={'User Sessions'}
          pagination={pagination}
          setPagination={setPagination}
          actionName={source}
          saveLoading={createDataQuery?.isPending}
          tableName={source}
          builderData={tableHeadersQuery?.data?.data}
          uploadDataQuery={uploadDataQuery}
          queryKey={'airports-list'}
          addNewComponent={true}
          isFilter={false}
        />
        <ReactTable
          sorting={pagination.sort}
          setSorting={handleSorting}
          columnData={tableHeadersQuery?.data?.headers ? [...(tableHeadersQuery?.data?.headers || []), {
            header: 'Action',
            cell: ({row}) => (
              <Button 
                size='xs' 
                variant='light' 
                leftSection={<IconDeviceMobileX size={14} />} 
                color='red'
                onClick={() => {
                  setConfirmationModal({
                    id: row?.original?.id,
                    modal: true
                  })
                }}
              >
                Clear session
              </Button>
            )
          }] : []}
          loading={
            allRecordsQuery?.isLoading || tableHeadersQuery?.isLoading
          }
          // onRowClick={e => setEditModal({ data:e, modal: true})}
          totalNoOfPages={
            allRecordsQuery?.data?.metadata?.total_number_of_page
          }
          totalNoOfRecords={allRecordsQuery?.data?.metadata?.records}
          rowData={allRecordsQuery?.data?.data}
          page={pagination?.page}
          setPage={page => setPagination({ ...pagination, page })}
        />
      </Body>
      <Modal opened={Boolean(confirmationModal?.modal)} title={'Are you sure?'} onClose={() => setConfirmationModal({})} size={'xs'}>
        <Text c={COLORS.textColor.black} size='14px'>Do you want to clear the session</Text>
        <Group justify='end' mt={'lg'}>
          <Button
            variant='light'
            color='gray'
            size='xs' onClick={() => setConfirmationModal({})}>Cancel</Button>
          <Button size='xs' color={COLORS.primary} onClick={() => {
            deleteDataQuery.mutate(confirmationModal?.id, {
              onSuccess: () => {
                displayNotification({
                  message: 'Session cleared successfully',
                  variant: 'success'  
                })
              },
              onError: (e) => {
                displayNotification({
                  message: e?.message || e,
                  variant: 'error'  
                })
              },
              onSettled: () => {
                allRecordsQuery?.refetch()
                setConfirmationModal({})
              }
            })
          }}>Confirm</Button>
        </Group>
      </Modal>
    </>
  )
}

export default UserSessionMaster
